<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5ba8MU/tc-custom/9780795351471.jpg?1728259235983" alt="This image is the cover for the book American Dreams Trilogy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">American Dreams Trilogy
      </h1>
      <p class="bookDescription body article font2">
        <b>All three novels in the acclaimed Christian author’s historical fiction series about a Southern family following God’s will as Civil War tensions rise.</b><br/><br/><i>Dream of Freedom</i><br/><br/>In the pre-Civil War South, Richmond Davidson and his family decide to follow God’s will and free their slaves. The controversy over this decision sets off escalating tensions as the lines are being drawn between North and South.<br/><br/><i>Dream of Life</i><br/><br/>When the Underground Railroad hears that the Davidson family home is a potential safe house, runaways began appearing at their door. Unable to turn them away, the Davidsons must find a way to help. But the prying eyes of neighbors make this a dangerous calling.<br/><br/><i>Dream of Love</i><br/><br/>As the Civil War rages, the Davidsons continue their work with the Underground Railroad. But as one son fights for the Confederacy while another has gone North, the family will face its most difficult trials yet.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Phillips
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Booksurge
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?443bd0c0